import { Component } from "react";
import ServerErrorPage from "../pages/ServerErrorPage";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorRef: null };
  }

  static getDerivedStateFromError(_error) {
    // Generate a short ref so support can correlate with logs
    const errorRef = "err_" + Math.random().toString(36).slice(2, 10).toUpperCase();
    return { hasError: true, errorRef };
  }

  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary caught:", error, errorInfo);
    // Optional: send to a logging endpoint here
  }

  render() {
    if (this.state.hasError) {
      return <ServerErrorPage errorRef={this.state.errorRef} />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
